import React, {useContext} from "react";
import Headroom from "react-headroom";
import "./Header.scss";
import ToggleSwitch from "../ToggleSwitch/ToggleSwitch";
import StyleContext from "../../contexts/StyleContext";
import {
  whitepaperSection,
  missionSection,
  teamSection,
  digitalTwinsSection,
  conceptInfo
} from "../../portfolio";

function Header() {
  const {isDark} = useContext(StyleContext);
  const viewWhite = whitepaperSection.display;
  const viewMission = missionSection.display;
  const viewDigitalTwins = digitalTwinsSection.display;
  const viewTeam = teamSection.display;  
  const viewConcept = conceptInfo.display;

  return (
    <Headroom>
      <header className={isDark ? "dark-menu header" : "header"}>
        <a href="/" className="logo">
          <img 
            src={require("../../assets/images/skyfall_logo_long.png")}
            alt="Skyfall Space Logo" 
            className="logo"
          />
        </a>
        <input className="menu-btn" type="checkbox" id="menu-btn" />
        <label
          className="menu-icon"
          htmlFor="menu-btn"
          style={{color: "white"}}
        >
          <span className={isDark ? "navicon navicon-dark" : "navicon"}></span>
        </label>
        <ul className={isDark ? "dark-menu menu" : "menu"}>
          {viewMission && (
            <li>
              <a href="#mission">Mission</a>
            </li>
          )}
          {viewConcept && (
            <li>
              <a href="#concept">Concept</a>
            </li>
          )}
          {viewWhite && (
            <li>
              <a href="#whitepaper">White Paper</a>
            </li>
          )}          
          {viewDigitalTwins && (
            <li>
              <a href="#digitalTwins">Digital Twins</a>
            </li>
          )}
          {viewTeam && (
            <li>
              <a href="#team">Team</a>
            </li>
          )}
          <li>
            <a href="#contact">Contact</a>
          </li>
          <li>
            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
            <a>
              <ToggleSwitch />
            </a>
          </li>
        </ul>
      </header>
    </Headroom>
  );
}
export default Header;
